/**
 * useReverseGeocode
 * Layer: presentation/hooks (employees module)
 * Change: manejo-de-coordenadas-y-mapas
 *
 * React Query wrapper for ReverseGeocodeUseCase.
 * Query is disabled when both lat and lng are 0 (null island).
 * staleTime: 10 min — addresses don't change between refreshes.
 */
import { useQuery } from '@tanstack/react-query';
import { reverseGeocodeUseCase } from '@/shared/geocoding/reverseGeocodeUseCase';

export function useReverseGeocode(lat: number, lng: number) {
  return useQuery({
    queryKey: ['reverse-geocode', lat, lng],
    queryFn: () => reverseGeocodeUseCase(lat, lng),
    enabled: lat !== 0 || lng !== 0,
    // Remote-only: HTTP geocoding call, no local fallback
    networkMode: 'online',
    staleTime: 10 * 60 * 1000,
    retry: 1,
  });
}
